import SalesAdvertisingPlanReportLayout from './salesAdvertisingPlanReportLayout';

export default SalesAdvertisingPlanReportLayout;
